// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Zp-c-","qr_code":"Footer_qr_code__sCQnA","btn":"Footer_btn__4mPKf"};